// extracted by mini-css-extract-plugin
export var container = "_lt-0";
export var dotAnimation = "_lt-2";
export var dotsLoading = "_lt-1";